export default __webpack_public_path__ + "static/media/microsoft.22c02c5a.png";